import { render, staticRenderFns } from "./ElementButton.vue?vue&type=template&id=a9e64cbc&"
import script from "./ElementButton.vue?vue&type=script&lang=js&"
export * from "./ElementButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports